import type { TemplateResourceListResponseV2Api } from '@ingenico/api-sdk-device-management-private-v2';
import type { BasicTemplateResourceBasicFront } from '@ingenico/react-configuration-generator';
import { toString } from 'lodash-es';

export function mapTemplateResourceListResponseApiToBasicTemplateResourceList(
  templates: TemplateResourceListResponseV2Api,
): BasicTemplateResourceBasicFront[] {
  return templates.data.map((template) => ({
    id: template.id,
    name: toString(template.name),
    description: toString(template.description),
    templateFileId: toString(template.templateFileId),
    targetLocation: template.targetLocation,
    templateFilename: template.templateFileName,
    templateFileVersion: toString(template.templateFileVersion),
  }));
}
